import React from 'react'
import roproductsindusrty from "../images/Aqua Dimon Ro.png";
import cripump from "../images/CRI PUMP.png";
import rosystem from "../images/products new.jpg"

import royalcripumb from "../images/Royal CRI Pump.png";
import UVWaterSterilizer from "../images/UV Water Sterilizer.png";
import EzeDoseRO from "../images/EzeDose RO Specialist Product Showcase.png";

const phoneNumber = "918016683916"; // 👉 Your number with country code
const message = "Hello, I want to know more about your services";

const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
};

function Products() {
    return (
        <div>
           
            <div className="album py-2">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-4 mt-2">
                            <div class="card">
                                <img src={roproductsindusrty} className="card-img-top" alt="roproductsindusrty" />

                                <div className="card-body">
                                    <h3 style={{ color: '#050c5c' }} className="card-title mb-1">RO Industry</h3>
                                   
                                    <p className='mb-2'>High-quality RO water purification systems and solutions for residential, commercial, and industrial applications.</p>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 8016683916'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="card">


                                <img src={cripump} className="card-img-top" alt="cripump" />

                                <div className="card-body">
                                    <h3 style={{ color: '#072461' }} className="card-title mb-1">C.R.I Pump</h3>
                                 
                                    <p className='mb-1'>Reliable and efficient water pumping solutions designed for residential, commercial, agricultural, and industrial applications.</p>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 8016683916'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={rosystem} className="card-img-top" alt="rosystem" />

                                <div class="card-body">
                                    <h3 style={{ color: '#051063' }} className="card-title mb-1">RO Industry</h3>
                                    <p className='mb-2'>High-quality RO water purification systems and solutions for residential, commercial, and industrial applications.</p>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 8016683916'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={royalcripumb} className="card-img-top" alt="royalcripumb" />

                                <div class="card-body">
                                    <h3 style={{ color: '#051063' }} className="card-title mb-1">Royal C.R.I Pumps</h3>
                                    <p className='mb-2'>Reliable and efficient pumping solutions for residential, agricultural, commercial, and industrial water applications.</p>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 8016683916'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={UVWaterSterilizer} className="card-img-top" alt="UVWaterSterilizer" />

                                <div class="card-body">
                                    <h3 style={{ color: '#051063' }} className="card-title mb-1">UV Water Sterilizer</h3>
                                    <p className='mb-2'>Advanced UV technology for effective water disinfection, helping eliminate harmful bacteria and microorganisms for safe, purified water.</p>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 8016683916'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>


                         <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={EzeDoseRO} className="card-img-top" alt="EzeDoseRO" />

                                <div class="card-body">
                                    <h3 style={{ color: '#051063' }} className="card-title mb-1">EzeDose RO Specialist</h3>
                                    <p className='mb-2'>A premium product display highlighting EzeDose RO Specialist with a clean, modern design.</p>
                                    <div className="d-flex justify-content-between align-items-center mb-0">
                                        <a className='call' href='tel: 8016683916'>Call Now</a>
                                        <button onClick={handleClick} className='whatsapp'>
                                            Chat on WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />

        </div>
    )
}

export default Products